module.exports = {
	withCart: withCart,
	loadScheduledEventFromSession: loadScheduledEventFromSession
}

var steps = ['product', 'booking', 'booking-itinerary', 'booking-contact', 'booking-summary', 'booking-payment', 'my-booking']

/**
 * @param {object} initObj Base cart object, if any
 * @param {number[]} doSchedule Scheduled steps
 * @param {boolean} isPushDisabled Flag to disabled pushing event
 * @returns {GtmCart} `GtmCart`
 */
function withCart (initObj, doSchedule, isPushDisabled) {
	return new GtmCart(initObj)
}

/**
 * @constructor
 * @param {object} initObj Base cart object, if any
 * @param {number[]} doSchedule Scheduled steps
 * @param {boolean} isPushDisabled Flag to disabled pushing event
 * @returns {GtmCart} `GtmCart`
 */
function GtmCart (initObj, doSchedule, isPushDisabled) {
	if (this) {
		this.cart = initObj || {}
		this.doSchedule = doSchedule
		this.isPushDisabled = !!isPushDisabled
	} else if (this === undefined) { // This one is used for casting
		return arguments[0]
	} else { // This might never happen
		this.cart = undefined
		this.doSchedule = undefined
		this.isPushDisabled = undefined
	}
}

/**
 * @param {boolean} denyClearPrevious Do not clear previous ecommerce object
 * @returns {void} `void`
 */
GtmCart.prototype.push = function push (denyClearPrevious) {
	var self = this

	// Silently finish
	if (self.isPushDisabled) {
		return
	}

	// Just schedule
	if (self.doSchedule) {
		scheduleEventCartOnSession(self.cart, self.doSchedule)
		return
	}

	if (Object.keys(self.cart).length > 0) {
		window.dataLayer = window.dataLayer || []
		if (!denyClearPrevious) {
			dataLayer.push({ ecommerce: null })  // Clear the previous ecommerce object.
		}
		dataLayer.push(self.cart)
		// For debugging
		storeCartHistoryOnSession(self.cart)
		console.debug(JSON.stringify({ 'GtmCart.push()': self.cart }, null, 2))
	} else {
		console.debug('Nothing to push')
		console.trace('GtmCart.push')
	}
}

/**
 * @param {object} model
 * @returns {GtmCart} `self`
 */
GtmCart.prototype.addToCart = function addToCart (model) {
	var self = this
	// Measure adding a product to a shopping cart by using an 'add' actionFieldObject
	// and a list of productFieldObjects.

	var productInfo
	var currency

	if (!model) {
		console.log('addToCart: NO MODEL')
		return self
	}

	if (model.isTour) {
		productInfo = getTourProductFromModel(model)
		currency = productInfo.currency
		// delete productInfo.dimension2
		// delete productInfo.dimension3
		// delete productInfo.dimension4
		// delete productInfo.dimension5
		delete productInfo.currency
	}

	if (model.isExperience) {
		productInfo = getExperienceProductFromModel(model)
		currency = productInfo.currency
		// delete productInfo.dimension2
		// delete productInfo.dimension3
		// delete productInfo.dimension4
		// delete productInfo.dimension5
		delete productInfo.currency
	}

	self.cart.event = self.event || 'eec.add'
	self.cart.ecommerce = self.cart.ecommerce || {}
	self.cart.ecommerce.currencyCode = self.cart.ecommerce.currencyCode || currency
	self.cart.ecommerce.add = self.cart.ecommerce.add || {}
	self.cart.ecommerce.add.products = self.cart.ecommerce.add.products || []

	self.cart.ecommerce.add.products.push(productInfo)

	return self
}

/**
 * @param {object} model
 * @returns {GtmCart} `self`
 */
GtmCart.prototype.removeFromCart = function removeFromCart (model) {
	var self = this
	// Measure the removal of a product from a shopping cart.

	var productInfo

	if (!model) {
		console.log('removeFromCart: NO MODEL')
		return self
	}

	if (model.isTour) {
		productInfo = getTourProductFromModel(model)
		delete productInfo.dimension1
		delete productInfo.dimension2
		delete productInfo.dimension3
		delete productInfo.dimension4
		delete productInfo.dimension5
		delete productInfo.currency
	}

	if (model.isExperience) {
		productInfo = getExperienceProductFromModel(model)
		delete productInfo.dimension1
		delete productInfo.dimension2
		delete productInfo.dimension3
		delete productInfo.dimension4
		delete productInfo.dimension5
		delete productInfo.currency
	}

	self.cart.event = self.event || 'eec.remove'
	self.cart.ecommerce = self.cart.ecommerce || {}
	self.cart.ecommerce.remove = self.cart.ecommerce.remove || {}
	self.cart.ecommerce.remove.products = self.cart.ecommerce.remove.products || []

	self.cart.ecommerce.remove.products.push(productInfo)

	return self
}

/**
 * @param {object} actionInfo
 * @param {string} actionInfo.currentStep
 * @param {number} actionInfo.stepAmount
 * @returns {GtmCart} `self`
 */
GtmCart.prototype.changeStep = function changeStep (actionInfo) {
	var self = this

	var currentStepIndex = steps.indexOf(actionInfo.currentStep)
	var nextStepIndex = currentStepIndex + actionInfo.stepAmount
	var nextStep = steps[nextStepIndex]

	// Skip steps
	if (nextStepIndex < 2 || nextStepIndex > 5) {
		this.isPushDisabled = true
		return self
	}

	console.debug('gtm event: nextStep => ' + nextStep)

	self.cart.event = self.event || 'eec.checkout_step_' + nextStepIndex
	self.cart.ecommerce = self.cart.ecommerce || {}
	self.cart.ecommerce.checkout = self.cart.ecommerce.checkout || {}
	self.cart.ecommerce.checkout.actionField = self.cart.ecommerce.checkout.actionField || {}
	self.cart.ecommerce.checkout.actionField.step = nextStepIndex

	return self
}

/**
 * @param {object} actionInfo
 * @param {string} actionInfo.currentStep
 * @param {object} model
 * @returns {GtmCart} `self`
 */
GtmCart.prototype.checkoutCart = function checkoutCart (actionInfo, model) {
	var self = this
	// Measure adding a product to a shopping cart by using an 'checkout' actionFieldObject
	// and a list of productFieldObjects.

	var productInfo
	var currency
	var currentStepIndex = steps.indexOf(actionInfo.currentStep)

	// Only run on step 1
	if (currentStepIndex !== 1) {
		this.isPushDisabled = true
		return self
	}

	if (!model) {
		console.log('checkoutCart: NO MODEL')
		return self
	}

	if (model.isTour) {
		productInfo = getTourProductFromModel(model)
		currency = productInfo.currency
		delete productInfo.dimension1
		//delete productInfo.dimension2
		//delete productInfo.dimension3
		//delete productInfo.dimension4
		//delete productInfo.dimension5
		delete productInfo.currency
	}

	if (model.isExperience) {
		productInfo = getExperienceProductFromModel(model)
		currency = productInfo.currency
		delete productInfo.dimension1
		//delete productInfo.dimension2
		//delete productInfo.dimension3
		//delete productInfo.dimension4
		//delete productInfo.dimension5
		delete productInfo.currency
	}

	self.cart.event = self.event || 'eec.checkout'
	self.cart.ecommerce = self.cart.ecommerce || {}
	self.cart.ecommerce.currencyCode = self.cart.ecommerce.currencyCode || currency
	self.cart.ecommerce.checkout = self.cart.ecommerce.checkout || {}
	self.cart.ecommerce.checkout.products = self.cart.ecommerce.checkout.products || []

	self.cart.ecommerce.checkout.actionField = self.cart.ecommerce.checkout.actionField || {}
	self.cart.ecommerce.checkout.actionField.step = currentStepIndex

	self.cart.ecommerce.checkout.products.push(productInfo)

	return self
}

/**
 * @param {object} actionInfo
 * @param {string} actionInfo.currentStep
 * @param {string} actionInfo.transactionId
 * @param {string} actionInfo.revenue
 * @param {string} actionInfo.affiliation
 * @param {object} model
 * @returns {GtmCart} `self`
 */
GtmCart.prototype.purchaseCart = function purchaseCart (actionInfo, model) {
	var self = this
	// Measure adding a product to a shopping cart by using an 'purchase' actionFieldObject
	// and a list of productFieldObjects.

	var productInfo
	var currency
	var transactionId = actionInfo.transactionId
	var revenue = actionInfo.revenue
	var affiliation = actionInfo.affiliation

	var currentStepIndex = steps.indexOf(actionInfo.currentStep)

	// Only run on step 3
	if (currentStepIndex !== 3) {
		this.isPushDisabled = true
		return self
	}

	if (!model) {
		console.log('purchaseCart: NO MODEL')
		return self
	}

	// Schedule to step 5
	self.doSchedule = [5]

	if (model.isTour) {
		productInfo = getTourProductFromModel(model)
		currency = productInfo.currency
		delete productInfo.dimension1
		delete productInfo.dimension2
		delete productInfo.dimension3
		delete productInfo.dimension4
		delete productInfo.dimension5
		delete productInfo.currency
	}

	if (model.isExperience) {
		productInfo = getExperienceProductFromModel(model)
		currency = productInfo.currency
		delete productInfo.dimension1
		delete productInfo.dimension2
		delete productInfo.dimension3
		delete productInfo.dimension4
		delete productInfo.dimension5
		delete productInfo.currency
	}

	self.cart.event = self.event || 'eec.purchase'
	self.cart.ecommerce = self.cart.ecommerce || {}
	self.cart.ecommerce.currencyCode = self.cart.ecommerce.currencyCode || currency
	self.cart.ecommerce.purchase = self.cart.ecommerce.purchase || {}

	self.cart.ecommerce.purchase.actionField = self.cart.ecommerce.purchase.actionField || {}
	self.cart.ecommerce.purchase.actionField.id = transactionId // $('#bookingId').val()
	self.cart.ecommerce.purchase.actionField.revenue = revenue // $('#bookingTotalPrice').val()
	self.cart.ecommerce.purchase.actionField.affiliation = affiliation // location.hostname

	self.cart.ecommerce.purchase.products = self.cart.ecommerce.purchase.products || []
	self.cart.ecommerce.purchase.products.push(productInfo)

	return self
}

// ####################################################################################################################

function getTourProductFromModel (model) {
	var productInfo = {
		quantity: 1 // Always 1 item
	}

	var tourData = model.tourAnalyticalData || {}
	var dynamicTourPrice = typeof model.getTourPrice === 'function' ? model.getTourPrice() : undefined
	var dynamicTourStartMonth = typeof model.getTourStartMonth === 'function' ? model.getTourStartMonth() : undefined
	var dynamicTourIs65Days = typeof model.getTourIs65Days === 'function' ? model.getTourIs65Days() : undefined

	productInfo.name = tourData.tourTitle
	productInfo.id = tourData.tourId ? String(tourData.tourId).replace(/-/g, '') : ''
	productInfo.price = castString(dynamicTourPrice) || castString(tourData.price)
	productInfo.brand = tourData.season
	productInfo.category = tourData.destination
	productInfo.variant = tourData.tourType

	// Conditional properties
	productInfo.dimension1 = dynamicTourStartMonth || getCurrentMonth()
	productInfo.dimension2 = tourData.roomAdults
	productInfo.dimension3 = tourData.roomChildren
	productInfo.dimension4 = tourData.roomInfants
	productInfo.dimension5 = dynamicTourIs65Days
	productInfo.currency = tourData.currency

	return productInfo
}

function getExperienceProductFromModel (model) {
	var productInfo = {
		quantity: 1 // Always 1 item
	}

	var experienceData = model.experienceAnalyticalData || {}
	var dynamicExperiencePrice = typeof model.getExperiencePrice === 'function' ? model.getExperiencePrice() : undefined
	var dynamicExperienceStartMonth = typeof model.getExperienceStartMonth === 'function' ? model.getExperienceStartMonth() : undefined
	var dynamicExperienceIs65Days = typeof model.getExperienceIs65Days === 'function' ? model.getExperienceIs65Days() : undefined

	productInfo.name = experienceData.experienceTitle
	productInfo.id = experienceData.experienceId ? String(experienceData.experienceId).replace(/-/g, '') : ''
	productInfo.price = dynamicExperiencePrice || experienceData.price
	productInfo.brand = experienceData.season
	productInfo.category = experienceData.destination
	productInfo.variant = experienceData.experienceType

	// Conditional properties
	productInfo.dimension1 = dynamicExperienceStartMonth || getCurrentMonth()
	productInfo.dimension2 = experienceData.adults
	productInfo.dimension3 = experienceData.children
	productInfo.dimension4 = experienceData.infants
	productInfo.dimension5 = dynamicExperienceIs65Days
	productInfo.currency = experienceData.currency

	return productInfo
}

function getCurrentMonth () {
	try {
		var date = new Date()
		return date.toLocaleString('default', { month: 'long' }) + ' ' + date.getFullYear()
	} catch (e) { }
}

/**
 * @param {object} cart
 * @param {number|number[]} targetStepIndex
 */
function scheduleEventCartOnSession (cart, targetStepIndex) {
	targetStepIndex = forceArray(targetStepIndex)
	var scheduledGtmEvent = sessionStorage.getItem('scheduledGtmEvent')
	var cartByIndex = scheduledGtmEvent ? JSON.parse(scheduledGtmEvent) : {}
	targetStepIndex.forEach(function (index) {
		cartByIndex[index] = cart
	})
	try {
		if (cart) {
			sessionStorageSafeSetItem('scheduledGtmEvent', JSON.stringify(cartByIndex))
		} else {
			sessionStorage.removeItem('scheduledGtmEvent')
		}
	} catch (e) { /* Ignore */ }
}

/**
 * @param {object} data
 * @param {string} currentStep
 * @returns {object} `cart`
 */
function loadScheduledEventFromSession (data, currentStep) {
	var currentStepIndex = steps.indexOf(currentStep)
	var scheduledGtmEvent = sessionStorage.getItem('scheduledGtmEvent')
	var cart
	if (scheduledGtmEvent) {
		var cartByIndex = JSON.parse(scheduledGtmEvent)
		cart = cartByIndex && cartByIndex[currentStepIndex]
		try {
			// Remove after loading
			if (cart) {
				delete cartByIndex[currentStepIndex]
				if (Object.keys(cartByIndex).length !== 0) {
					sessionStorageSafeSetItem('scheduledGtmEvent', JSON.stringify(cartByIndex))
				} else {
					sessionStorage.removeItem('scheduledGtmEvent')
				}
			}
		} catch (e) { /* Ignore */ }

		// TODO: run dynamically data retrieving functions
	}
	return cart
}

/**
 * For debugging purposes
 * @param {object} cart
 */
function storeCartHistoryOnSession (cart) {
	try {
		var lastGtmEvent = sessionStorage.getItem('lastGtmEvent')
		if (lastGtmEvent) {
			sessionStorageSafeSetItem('olderGtmEvent', lastGtmEvent)
		} else {
			sessionStorage.removeItem('olderGtmEvent')
		}
		if (cart) {
			sessionStorageSafeSetItem('lastGtmEvent', JSON.stringify(cart))
		} else {
			sessionStorage.removeItem('lastGtmEvent')
		}
	} catch (e) { /* Ignore */ }
}

function sessionStorageSafeSetItem (key, value) {
	try {
		sessionStorage.setItem(key, value)
	} catch (e) {
		sessionStorage.clear()
		sessionStorage.setItem(key, value)
	}
}

/**
 * @returns {[]}
 */
function forceArray (obj) {
	if (obj === null || obj === undefined) {
		return []
	} else if (!Array.isArray(obj)) {
		return [obj]
	}
	return obj
}

/**
 * @returns {string}
 */
function castString (obj) {
	if (typeof obj === 'number') {
		if (isNaN(obj)) return String(obj)
		return Number(obj).toFixed(2)
	} else if (obj !== null && obj !== undefined) {
		return String(obj)
	}
	return obj
}



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/gtm.js